import _styled from "@emotion/styled-base";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import { css } from "@emotion/core";
import { Link as RouterLink } from "react-router-dom";
import { compose, space, typography } from "styled-system";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { hideFocusRingOnClick } from "./css";
import { forwardInnerRef } from "./utils";

var StyledAnchor =
/*#__PURE__*/
_styled("a", {
  shouldForwardProp: shouldForwardProp,
  target: "e183hsg00"
})(function (_ref) {
  var theme = _ref.theme;
  return (
    /*#__PURE__*/
    css("label:base;background:transparent;border:0;margin:0;padding:0;cursor:pointer;color:", theme.colors.blue, ";transition-timing-function:ease-out;transition-duration:500ms;transition-property:background-color,border-color,color;text-align:inherit;&:link{text-decoration:none;transition-duration:0;}&:visited{text-decoration:none;transition-duration:0;}&:hover{color:", theme.colors.red, ";text-decoration:none;transition-duration:200ms;}&:active{color:", theme.colors.heading, ";text-decoration:none;transition-duration:0;}&:disabled{color:", theme.colors.blue, ";cursor:not-allowed;}")
  );
}, hideFocusRingOnClick, compose(space, typography));

function Link(_ref2) {
  var onClick = _ref2.onClick,
      to = _ref2.to,
      href = _ref2.href,
      fullNavigation = _ref2.fullNavigation,
      innerRef = _ref2.innerRef,
      props = _objectWithoutPropertiesLoose(_ref2, ["onClick", "to", "href", "fullNavigation", "innerRef"]);

  var as;
  var type;

  if (onClick != null) {
    as = "button";
    type = "button";
  } else if (to != null) {
    if (fullNavigation) {
      href = to;
    } else {
      as = RouterLink;
    }
  }

  return ___EmotionJSX(StyledAnchor, _extends({
    as: as,
    type: type
  }, props, {
    to: to,
    href: href,
    onClick: onClick,
    ref: innerRef
  }));
}

export default forwardInnerRef(Link);